// FLAGS: none
// Keyboard-and-click activation wrapper that turns a read-only display into an edit trigger.
import React from "react";

interface EditableDisplayProps {
  className: string;
  onActivate: () => void;
  children: React.ReactNode;
  "data-testid"?: string;
}

/**
 * A simple wrapper that renders its children inside a <div> with role=button, tabIndex=0,
 * an onClick/onKeyDown handler, and the provided className.
 * Use this to wrap any “read-only” display that should switch into “edit” mode when clicked or Enter/Space is pressed.
 */
const EditableDisplay: React.FC<EditableDisplayProps> = ({
  className,
  onActivate,
  children,
  "data-testid": testId,
}) => (
  <div
    className={className}
    role="button"
    tabIndex={0}
    onClick={onActivate}
    onKeyDown={(e) => {
      if (e.key === "Enter" || e.key === " ") {
        onActivate();
      }
    }}
    data-testid={testId}
  >
    {children}
  </div>
);

export default EditableDisplay;
